import { triniumApi } from '@api/Trinium/slice';
import { SalesPerson, transformSalesPersonResponse } from './types';

const salespeopleSlice = triniumApi.injectEndpoints({
	endpoints(builder) {
		return {
			fetchSalesPeople: builder.query<
				SalesPerson[],
				{
					terminalNumber: string;
					contains?: string;
				}
			>({
				query: ({ terminalNumber, contains }) => ({
					url: `/${terminalNumber}/salespeople`,
					params: contains
						? {
								contains
							}
						: undefined
				}),
				transformResponse: transformSalesPersonResponse
			})
		};
	}
});

export const { useFetchSalesPeopleQuery, useLazyFetchSalesPeopleQuery } = salespeopleSlice;
